import { joinWithAnd } from 'src/utils/extractRuleFromScheduleData';

export class Schedule {
  idSchedules?: number;
  rule: string;
  status?: 'A' | 'D';
  type: 'H' | 'D' | 'W' | 'M';
}

export function interpretServerSchedule(schedule: any): Schedule {
  return Object.assign(new Schedule(), schedule);
}

export function getLocalTimeString(schedule: Schedule): string {
  let obj;
  try {
    obj = JSON.parse(schedule.rule);
  } catch(err) {
    return err.toString();
  }
  const hours = typeof obj.hour === "number" ? [ obj.hour ] : obj.hour;
  const minute = obj.minute || 0;
  const times = hours.map(hour => ({ hour, minute }));
  const minutesOffset = ((new Date()).getTimezoneOffset());

  return joinWithAnd(times.map(time => {
    const localTime = time.hour * 60 + time.minute - minutesOffset;
    const isNegative = localTime < 0;
    const localHour = (isNegative ? 24 : 0) + Math.floor(localTime / 60);
    const localMinute = Math.floor((isNegative ? 60 : 0) + Math.floor(localTime % 60)) % 60;
    return `${localHour.toString().padStart(2, '0')}:${localMinute.toString().padStart(2, '0')}${isNegative ? '*': ''}`
  }));
}

/*
Obs: Rule is a JSON string of the following object:

type Rule = {
  year?: number | number[],
  month?: number | number[],
  date?: number | number[],
  dayOfWeek?: number | number[],
  hour?: number | number[] = 0,
  minute?: number | number[] = 0,
  second?: number | number[] = 0
}

Missing values (excluding hour, minute, seconds) are treated as * (every)
*/
